import { PublicLayout } from "./PublicLayout";
import { Hero } from "./Hero";
import { SpecStrip } from "./SpecStrip";
import { ProblemSection } from "./ProblemSection";
import { DesignEngineBand, SecurityBand } from "./HomePillars";
import { Transparency } from "./Transparency";
import { ToolShowcase } from "./ToolShowcase";
import { ControlSection } from "./ControlSection";
import { WhoFor } from "./WhoFor";
import { Proof } from "./Proof";
import { Pricing } from "./Pricing";
import { Faq } from "./Faq";
import { CtaBand } from "./CtaBand";
import { Reveal } from "./Reveal";

/* Home tells the story; depth lives on the deep pages (founder trim, 2026-07-11).
 * Deliverables + code/material coverage moved wholly to /platform/engineering —
 * the DesignEngineBand and FAQ carry the one-line teases. */
export function LandingPage() {
  return (
    <PublicLayout>
      <Hero />
      <SpecStrip />

      <Reveal><ProblemSection /></Reveal>
      <Reveal><DesignEngineBand /></Reveal>
      <Reveal><Transparency /></Reveal>
      <Reveal><ToolShowcase /></Reveal>
      <Reveal><ControlSection /></Reveal>
      <Reveal><WhoFor /></Reveal>
      <Reveal><SecurityBand /></Reveal>
      <Reveal><Proof /></Reveal>
      <Reveal><Pricing /></Reveal>
      <Reveal><Faq /></Reveal>
      <Reveal><CtaBand /></Reveal>
    </PublicLayout>
  );
}
